// Copyright 2016 Sorama B.V.

export enum ProgressType {
    Upload,
    Download,
    Processing,
}

export class ProgressIndicator {
    public progresType: ProgressType;
    public progressEvent: ProgressEvent;

    constructor(progresType: ProgressType, progressEvent: ProgressEvent) {
        this.progresType = progresType;
        this.progressEvent = progressEvent;
    }
}
